import React, { Component } from 'react';
import { string, func, object } from 'prop-types';
import { size } from 'lodash';
import styled from 'styled-components';
import { Icon, Text, Column, Row } from '../../common';

const InternalDrawerHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    margin: 0 -26px 16px -23px;
    padding: 0 16px 16px 23px;
`;

class InternalDrawerHeader extends Component {
    static propTypes = {
        title: string,
        subtitle: string,
        onClose: func,
        style: object,
        titleProps: object, 
    }

    static defaultProps = {
        title: '',
        subtitle: '',
        onClose: () => {},
        style: {},
        titleProps: {},
    }

    render () {
        const { title, subtitle, onClose, style, titleProps } = this.props;
        return (
            <InternalDrawerHeaderContainer style={style}>
                <Column>
                    <Row>
                        <Column flex={5}>
                            <Text noWrap text={title} size={20} {...titleProps}/>
                        </Column>
                        <Column noFlex padding={10}>
                            <Icon name='cross' pointer onClick={onClose} />
                        </Column>
                    </Row>
                    {size(subtitle) > 0 && <Column>
                        <Text text={subtitle} />
                    </Column>}
                </Column>
            </InternalDrawerHeaderContainer>
        );
    }
}

export default InternalDrawerHeader;
